<template>
  <div style="display: flex">
    <button class="button is-rounded is-small" :class="{'is-primary': selected_options.indexOf('all') > -1}" @click.prevent="addCriterion('all')">
      <span>Semua</span>
      <span class="icon" v-if="selected_options.indexOf('all') > -1"><i class="fa fa-times"></i></span>
    </button>
    <button class="button is-rounded is-small" :class="{'is-primary': selected_options.indexOf('classes') > -1}" @click.prevent="addCriterion('classes')">
      <span>Kelas</span>
      <span class="icon" v-if="selected_options.indexOf('classes') > -1"><i class="fa fa-times"></i></span>
    </button>
    <button class="button is-rounded is-small" :class="{'is-primary': selected_options.indexOf('news') > -1}" @click.prevent="addCriterion('news')">
      <span>Berita</span>
      <span class="icon" v-if="selected_options.indexOf('news') > -1"><i class="fa fa-times"></i></span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    dataProvider: {
      type: Object,
      required: true
    },
    clickHandler: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    search: {
      get() {
        const search = collect(this.dataProvider.criterion).where('criteria', 'title,description').first();

        return !this.isEmpty(search) ? search.value : '';
      },
      set(val) {
        this.dataProvider['criterion'] = collect(this.dataProvider.criterion).map((c) => {
          if (c.criteria == 'title,description') {
            c['value'] = val;
          }

          return c;
        }).toArray();
      }
    },
    criterion_type: {
      get() {
        const criterion_type = collect(this.dataProvider.criterion).where('criteria', 'type').first();

        return !this.isEmpty(criterion_type) ? criterion_type.value : '';
      },
      set(val) {
        this.dataProvider['criterion'] = collect(this.dataProvider.criterion).map((c) => {
          if (c.criteria == 'type') {
            c['value'] = val;
          }

          return c;
        }).toArray();
      }
    },
  },

  watch: {
    selected_options(val, oldval) {
      const vm = this;
      val = this.filterSelectedOption(collect(val).diff(oldval).first())
      this.setCriterion()
    }
  },

  data() {
    return {
      open: false,
      selected_options: ['classes'],
    }
  },

  methods: {
    filterSelectedOption(key) {
      let selected_options = _.cloneDeep(this.selected_options)

      if (key != 'all') {
        selected_options = [key]
      } else {
        selected_options = ['all']
      }

      return selected_options
    },
    setCriterion() {
      this.dataProvider['criterion'] = collect(this.dataProvider.criterion)
        .filter((c) => c.criteria != 'type')
        .push({criteria: 'type', value: this.selected_options, operator: 'EQ', custom: true})
        .toArray();
    },
    addCriterion(key) {
      const vm = this

      this.selected_options = this.filterSelectedOption(key)
      this.setCriterion()
      this.clickHandler(true);
    }
  }
}
</script>
